<template>
  <div class="d-flex justify-end mb-6">
    <v-btn
      icon
      class="mb-2 rounded-pill"
      @click="refreshTable"
      :loading="loading"
      :disabled="loading"
      :style="{ 'margin-right': '10px', 'margin-bottom': '32px' }"
    >
      <v-icon size="24" color="warning">mdi-refresh</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'TableTop',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    refreshTable: {
      type: Function,
      required: true,
    },
  },
};
</script>
